import React from 'react';
import { ErrorCommon, TextFieldCommon } from "../../formikFormInputs";
import { Grid } from "@material-ui/core";
import { FieldProps } from '../../formikFormInputs/TextFieldCommon';
import { FormikValues } from "formik/dist/types";

type AllProps = FieldProps & FormikValues;

export default function FormField(props: AllProps) {
  return (
    <Grid item
          xs={12}
          md={props.rowSize === 12 ? 12 : props.rowSize === 6 ? 6 : props.rowSize === 4 ? 4 : props.rowSize}>
      <TextFieldCommon
        {...props}
        values={props.values}
        onChange={props.handleChange}
        onBlur={props.handleBlur}
      />
      <ErrorCommon errors={props.errors} name={props.name} touched={props.touched}/>
    </Grid>
  );
}
